module.exports = __webpack_public_path__ + "img/Menu-05.74e34491.png";